module.exports = __webpack_public_path__ + "img/dashboard.d6b99d41.svg";